import Vue from 'vue'
import axios from 'axios'
import router from '../router/'
import {Loading, Message} from 'element-ui'
// 响应时间(过时不候，超时停止响应)
axios.defaults.timeout = 30 * 1000;
// 配置cookie
axios.defaults.withCredentials = false;
// 是否正在刷新的标志
window.isRefreshing = false;
// 存储请求的数组
let refreshSubscribers = [];
// 存储请求失败的数组
let reqNum = 0;
axios.defaults.isRetryRefresh = false;
// 配置请求头
axios.defaults.headers.common['token'] = sessionStorage.getItem('token')
axios.defaults.headers.post['Content-Type'] = 'application/json';
// 设置基础URL为后端服务api地址，开发阶段跨域调试时，应修改config/index.js下的proxyTable未服务地址和端口
// 配置接口地址(本地连接服务器调试时无需修改，打包给服务端前localhost无需修改，端口号修改为服务器端口号)
get('', '/static/json/getLocalPath.json').then(res => {
  axios.defaults.baseURL = res.localAddress + ':' + res.localPort;
  sessionStorage.setItem('baseURL', res.localAddress + ':' + res.localPort);
});
// 静态资源
Vue.prototype.$static = '/static';

// 将所有的请求都push到数组中
function subscribeTokenRefresh (cb) {
  refreshSubscribers.push(cb);
}

// 数组中的请求得到新的token之后自执行，用新的token去请求数据
function onRefreshed (token) {
  refreshSubscribers.map(cb => cb(token));
}

// 刷新token的请求方法
function getRefreshToken () {
  // refresh_token原使用存在本地的localstorage，由于localStorage关闭页面后不清除，改用sessionStorage
  return get('/sys', '/refreshToken')
}

// 获取登录时间戳
function loadTimeStamp () {
  return parseInt(sessionStorage.getItem('loginTimeStamp'));
}

// 刷新token的过期时间判断
function isRefreshTokenExpired () {
  let stamp = new Date().getTime() - loadTimeStamp();
  let minutes = (stamp % (1000 * 60 * 60)) / (1000 * 60); // 获取当前登录时长
  return minutes >= 15; // 设置15分钟刷新token
}

let loadingInstance
// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  config => {
    reqNum++;
    // if (config.method === 'post') {
    //   config.data = JSON.stringify(config.data)
    // }
    let url = config.url;
    if (url.indexOf('sys/login') > -1) {
      sessionStorage.setItem('token', '');
      config.headers.token = '';
    } else if (url.indexOf('getStatus') > -1) { // 定时查询状态不创建加载遮罩
      loadingInstance = null;
    } else {
      // 验证类和导入类请求不添加遮罩，防止页面闪烁
      if (url.indexOf('get') > -1 || url.indexOf('json') > -1) {
        // loadingInstance = null;
        // console.log('interceptor', url)
      } else if (url.indexOf('importSensor') > -1 || url.indexOf('downloads') > -1) {
        loadingInstance = 'test';
        config.responseType = 'blob';
      } else {
        loadingInstance = Loading.service({
          lock: true,
          text: '数据加载中，请稍后...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }
      if (sessionStorage.getItem('token')) {
        // 在请求头中添加token
        config.headers.token = sessionStorage.getItem('token');
        if (isRefreshTokenExpired()) {
          if (!window.isRefreshing) {
            console.log('请求刷新token');
            window.isRefreshing = true;
            getRefreshToken().then(res => {
              window.isRefreshing = false;
              sessionStorage.setItem('token', res.data);
              sessionStorage.setItem('loginTimeStamp', '' + new Date().getTime());
              config.headers.token = sessionStorage.getItem('token');
              console.log('token刷新成功：' + config.headers.token);
              onRefreshed(res.data);

              refreshSubscribers = [];
            }).catch(err => {
              sessionStorage.setItem('token', '');
              config.headers.token = '';
              alert('超时请重新登录');
              console.log(err);
              router.push({name: 'LoginPage'}).then(r => {})
            });
            return new Promise((resolve, reject) => {
              // (token) => {...}这个函数就是回调函数
              subscribeTokenRefresh((token) => {
                config.headers.token = token;
                /** 将请求挂起 */
                resolve(config)
              })
            });
          }
        }
      }
    }
    return config;
  },
  err => {
    reqNum++;
    if (loadingInstance) loadingInstance.close();
    Message.error('请求错误');
    return Promise.reject(err)
  }
)
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    reqNum--;
    if (res.data.code === 200) {
      if (loadingInstance) loadingInstance.close();
      return res;
    } else if (res.data.code === 201 || res.data.code === 401) {
      return res;
    } else if (res.data && res.data === '401') { // 401, token失效,清楚缓存，重新请求
      sessionStorage.setItem('token', '');
      router.push({name: 'LoginPage'});
    } else {
      // 无遮罩的请求，不提示错误消息
      if (loadingInstance) {
        if (loadingInstance === 'test') {
          let tempRes = {data: res};
          return tempRes;
        } else {
          loadingInstance.close();
          if (res.data.message) {
            Message.error(res.data.message);
          } else {
            return res;
          }
          return;
        }
      }
      return res;
    }
  },
  err => {
    reqNum--;
    if (loadingInstance) loadingInstance.close();
    if (reqNum === 0) Message.error('请求失败，请稍后再试');
    return Promise.reject(err)
  }
)
// 发送请求
export function post (preUrl, url, params, resType) {
  return new Promise((resolve, reject) => {
    axios
      .post(preUrl + url, params, resType)
      .then(
        res => {
          resolve(res.data)
        },
        err => {
          reject(err.data)
        })
      .catch(err => {
        reject(err.data)
      })
  })
}
export function get (preUrl, url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(preUrl + url, {
        params: params
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/interceptor.js